import Check from '@untitled-ui/icons-react/build/esm/Check'
import Tag02 from '@untitled-ui/icons-react/build/esm/Tag02'
import { BlackFridayBackdrop } from './black-friday-banner'
import { BLACK_FRIDAY_OFFER_URL } from './new-subscription-banner'

const spendLabel = (k: number) =>
	k >= 1000 ? `$${parseFloat((k / 1000).toFixed(2))}M` : `$${k}k`

export const NewSubscriptionBenefits = ({
	standardK,
	boostedK,
	isCustomPlan = false,
	couponCode = 'BLACKFRIDAY'
}: {
	standardK: number
	boostedK: number
	isCustomPlan?: boolean
	couponCode?: string
}) => (
	<div className="relative w-full overflow-hidden rounded-[10px] px-[12px] py-[10px] text-[rgb(var(--cg-text-on-brand))]">
		{/* Fainter ribbons than the bar: this block carries body text. */}
		<BlackFridayBackdrop ribbonOpacity={0.07} />
		{/* Locked campaign coupon and terms. */}
		<div className="relative mb-[8px] flex flex-wrap items-center justify-between gap-[8px]">
			{couponCode && (
				<span className="inline-flex items-center gap-[6px] rounded-md border border-white/40 bg-white/10 px-[6px] py-[2px]">
					<Tag02 className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
					<span className="font-grotesk text-[12px] leading-[16px] font-medium">
						{couponCode}
					</span>
				</span>
			)}
			<a
				href={BLACK_FRIDAY_OFFER_URL}
				target="_blank"
				rel="noreferrer"
				className="font-grotesk text-[12px] leading-[16px] font-medium underline underline-offset-2 hover:no-underline"
			>
				T&amp;C Apply
			</a>
		</div>
		<ul className="relative flex flex-col gap-[4px] font-grotesk text-[13px] leading-[18px]">
			<li className="flex gap-[8px]">
				<Check className="mt-[2px] w-3.5 h-3.5 shrink-0" aria-hidden="true" />
				<span>
					{isCustomPlan ? (
						'Custom price supplied by our team'
					) : (
						<>
							<s className="opacity-60">20%</s>{' '}
							<strong className="font-semibold">35% off</strong> your first year
						</>
					)}
				</span>
			</li>
			<li className="flex gap-[8px]">
				<Check className="mt-[2px] w-3.5 h-3.5 shrink-0" aria-hidden="true" />
				<span className="tabular-nums">
					<s className="opacity-60">{spendLabel(standardK)}</s>{' '}
					<strong className="font-semibold">{spendLabel(boostedK)}</strong> ad
					spend protection through Q4
				</span>
			</li>
		</ul>
	</div>
)
